<template>
  <v-col class="pa-0">
    <v-card class="border card-info mt-2">
      <div class="btn-device-map">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-bind="attrs"
              class="hover-scale-effect"
              v-on="on"
              @click="getResidentialComplexesIndividual"
            >
              <v-icon x-large color="black" class="icon-doorphone-map">mdi-home-map-marker</v-icon>
            </v-btn>
          </template>
          <span>Объект на карте</span>
        </v-tooltip>
      </div>
      <div class="pa-4">
        <div class="flex-container" v-if="barrier.doors.length >= 2">
          <div class="mb-2">
              <span class="" style="color: crimson">
                Шлагбаум оснащен вторым реле, которое подключено и функционирует.
              </span>
          </div>
        </div>
        <div class="flex-container" v-if="barrier.physical_status === 5">
          <div class="mb-2">
              <span class="" style="color: crimson">
                Шлагбаум имеет устройство старого образца.
              </span>
          </div>
        </div>
        <div class="flex-container" v-if="oldBarrierAppOpeningHint">
          <div class="mb-2">
            <span style="color: #4C6C93; white-space: pre-line;">{{ oldBarrierAppOpeningHint }}</span>
          </div>
        </div>
        <div class="flex-container" v-if="barrier.forbid_guest_access">
          <div class="mb-2">
              <span class="" style="color: crimson">
                Запрещён гостевой доступ в мобильном приложении по ГРЗ.
              </span>
          </div>
        </div>
        <div class="flex-container" v-if="barrier.forbid_client_add_car_numbers">
          <div class="mb-2">
              <span class="" style="color: crimson">
                Клиентам запрещено добавлять номера автомобилей (только УК может добавлять).
              </span>
          </div>
        </div>
        <div v-for="(item, index) in infoDevices1" :key="index">
          <LabelValueInfo
            :label="item.label"
            :value="item.value"
            :check="item.check"
            :br-check="item.brCheck"
            :is-check-size-small="isCheckSizeSmall"
          />
        </div>
        <div class="flex-container">
          <div class="label">
            <p></p>
          </div>
          <div class="border-left"></div>
          <div class="content mb-4 ml-1">
            <span @click="openAdditionalAddressesModal" class="additional-addresses">
              Дополнительные адреса
            </span>
          </div>
        </div>
        <AdditionalAddressModal
          ref="additionalModal"
          :data-addresses="barrier.additional_addresses"
          @add-address="handleAddAddress"
          @remove-address="handleRemoveAddress"
          :is-check-size-small="isCheckSizeSmall"
          :is-adding-address="true"
        />
        <div class="flex-container">
          <div class="label">
            <p>SIP статус</p>
          </div>
          <div class="border-left"></div>
          <div class="content">
              <span class="device-info">
                <v-icon
                  x-small
                  :color="sipStatusColor"
                >
                  mdi-checkbox-blank-circle
                </v-icon>
                    {{ sipStatusText }}
                    <v-btn
                      v-if="!isWithoutMonitoring && $checkPermission('import_sip_status_barrier')"
                      x-small
                      color="primary"
                      icon
                      :loading="isUpdatedSip"
                      @click.prevent="updateSipStatus()"
                    >
                    <v-icon small button color="primary">mdi-cached</v-icon>
                    </v-btn>
              </span>
          </div>
        </div>
        <div class="flex-container" v-if="!isWithoutMonitoring">
          <div class="label">
            <p></p>
          </div>
          <div class="border-left"></div>
          <div class="content">
            <history-sip-status-dialog
              :is-check-size-small="isCheckSizeSmall"
              :sip-history="sipHistory"
              type="barrier"
            />
          </div>
        </div>
      </div>
    </v-card>
    <v-card class="border card-info mt-4">
      <div class="pa-4">
        <div v-for="(item, index) in infoDevices2" :key="index">
          <LabelValueInfo
            :label="item.label"
            :value="item.value"
            :check="item.check"
            :br-check="item.brCheck"
            :is-check-size-small="isCheckSizeSmall"
          />
        </div>
      </div>
    </v-card>
    <v-card class="border card-info mt-4">
      <div class="pa-4">
        <div v-for="(item, index) in infoDevices3" :key="index">
          <div v-if="item.label === 'Тип открытия' && item.check" class="flex-container">
            <div class="label">
              <p>Тип открытия</p>
            </div>
            <div class="border-left"></div>
            <div class="content">
              <span class="device-info">
                <opening-type-text :opening-type="barrier.opening_type">
                  <template v-slot:after="{ type }">
                    <v-tooltip
                      v-if="showOpeningAppViaGsmHint && type === 'C'"
                      bottom
                      max-width="320"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-bind="attrs"
                          v-on="on"
                          small
                          color="#4C6C93"
                          class="ml-1"
                          @click.stop
                        >
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>
                        В данном случае клиент может открывать шлагбаум через приложение.
                        Открытие выполняется звонком на GSM-модуль; для клиента визуально нет отличия.
                      </span>
                    </v-tooltip>
                  </template>
                </opening-type-text>
              </span>
            </div>
          </div>
          <LabelValueInfo
            v-else
            :label="item.label"
            :value="item.value"
            :check="item.check"
            :br-check="item.brCheck"
            :is-check-size-small="isCheckSizeSmall"
          />
        </div>
        <div class="flex-container" v-if="hasTechnicalComment">
          <div class="label">
            <p>Технический комментарий</p>
          </div>
          <div class="border-left"></div>
          <div class="content">
            <expandable-text :key="`barrier-tech-comment-${barrier.id}`" :text="barrier.technical_comment" :max-length="64" />
          </div>
        </div>
      </div>
    </v-card>
  </v-col>
</template>
<script>
import ruDateFormatMixin from '@/mixins/ruDateFormat';
import LabelValueInfo from '@/components/LabelValueInfo';
import historySipStatusDialog from '@/components/HistorySipStatusDialog';
import AdditionalAddressModal from './AdditionalAddressModal.vue';
import ExpandableText from '@/components/ExpandableText';
import OpeningTypeText from '@/components/barrier/OpeningTypeText';
import {
  TYPE_BARRIER, ENTRY_REMOTE_CONTROLS,
  DIRECTION_MOVEMENTS, DISPLAY_IN_APP, STATUS_CONDITION, ENUM_LABELS,
  isBarrierWithoutMonitoring, getBarrierSipStatusColor, getBarrierSipStatusText,
  parseOpeningTypeValues,
} from '../../../../consts';
import { mapActions, mapGetters } from 'vuex';

export default {
  components: { LabelValueInfo, historySipStatusDialog, AdditionalAddressModal, ExpandableText, OpeningTypeText },
  mixins: [ruDateFormatMixin],
  name: 'DetailedInfo',
  props: {
    barrier: {
      type: Object,
      required: true,
    },
    isCheckSizeSmall: {
      type: Boolean,
    },
  },
  data () {
    return {
      dialogHistory: false,
      isUpdatedSip: false,
      sipHistory: [],
    };
  },
  created () {
    if (this.$checkPermission('view_sip_status_logs')) {
      this.getSipHistory(this.$route.params.id)
        .then((data) => {
          this.sipHistory = data;
        });
    }
  },
  computed: {
    ...mapGetters({
      agents: 'Agents/agents',
    }),
    displayTitle () {
      if (this.barrier.passage_type === 'G') {
        return 'Ворота';
      }
      return 'Шлагбаум';
    },
    getAgentName () {
      const agent = this.agents.find(agent => agent.id === this.barrier.agent_id);
      if (agent) {
        return agent.user.name;
      }
      return this.barrier.physical_status === 5 ? 'ООО "КОМПАНИЯ ВОЛНА"' : 'Неизвестный агент';
    },
    getAgentTelephone () {
      const agent = this.agents.find(agent => agent.id === this.barrier.agent_id);
      if (agent) {
        return agent.dispatcher_phone;
      }
      return this.barrier.physical_status === 5 ? '278787' : 'Неизвестный номер';
    },
    infoDevices1 () {
      return [
        { label: this.displayTitle, value: `${this.displayTitle} № ${this.barrier.id}`, check: '1' },
        { label: 'Город', value: this.barrier.address.split(' ')[0], check: this.barrier.address, brCheck: true },
        { label: 'Район', value: this.barrier.region_name, check: this.barrier.region_name },
        { label: 'Дата установки', value: this.ruDateFormat(this.barrier.created_at), check: this.barrier.created_at },
        { label: 'Адрес', value: this.barrier.address, check: this.barrier.address },
      ];
    },
    infoDevices2 () {
      return [
        { label: 'Название в моб. приложении', value: this.barrier.name ? this.barrier.name : '', check: '1' },
        { label: 'Управляющая компания', value: this.barrier.management_company, check: this.barrier.management_company },
        // Агент
        { label: 'Компания по тех. обслуживанию', value: this.getAgentName, check: '1' },
        { label: 'Номер компании по тех. обслуживанию', value: this.getAgentTelephone, check: '1', brCheck: true },
        { label: 'Физический статус', value: this.physicalStatus(this.barrier.physical_status), check: this.barrier.physical_status },
        { label: 'Видимость в моб. приложении', value: this.visibilityInAppLabel, check: '1' },
        {
          label: 'Реле открытия',
          value: this.barrier.doors.map(door => `Реле №${door.doornum}, ${door.name}`).join('; '),
          check: this.barrier.doors.length,
        },
        { label: 'Тип договора на обслуживание', value: this.displayLabelSettings('contract_type', this.barrier.contract_type), check: '1' },
      ];
    },
    isWithoutMonitoring () {
      return isBarrierWithoutMonitoring(this.barrier);
    },
    sipStatusColor () {
      return getBarrierSipStatusColor(this.barrier);
    },
    sipStatusText () {
      return getBarrierSipStatusText(this.barrier);
    },
    hasTechnicalComment () {
      return Boolean(this.barrier?.technical_comment && String(this.barrier.technical_comment).trim());
    },
    hasGsmModule () {
      if (this.barrier.gsm_module || this.barrier.gsm_module_device_id) {
        return true;
      }
      const gsmType = this.barrier.gsm_module_type;
      return Boolean(gsmType && gsmType !== 'None');
    },
    isOldSampleBarrier () {
      return this.barrier.physical_status === 5;
    },
    hasAppOpeningType () {
      return parseOpeningTypeValues(this.barrier.opening_type).includes('A');
    },
    showOpeningAppViaGsmHint () {
      return this.hasGsmModule &&
        this.barrier.display_in_app &&
        !this.hasAppOpeningType;
    },
    oldBarrierAppOpeningHint () {
      if (!this.isOldSampleBarrier || this.hasAppOpeningType) {
        return '';
      }
      if (!this.barrier.display_in_app) {
        return 'Шлагбаум не отображается в приложении. Доступны только способы из типа открытия (звонок / пульт).';
      }
      if (this.hasGsmModule) {
        return [
          'Шлагбаум отображается в приложении, открытие через приложение присутствует.',
          'Для клиента визуально нет отличия: в приложении всё выглядит как обычно.',
        ].join('\n');
      }
      return [
        'Шлагбаум отображается в приложении, но GSM-модуль не указан — открытие из приложения недоступно.',
      ].join('\n');
    },
    visibilityInAppLabel () {
      if (this.isOldSampleBarrier && this.barrier.display_in_app && this.hasGsmModule && !this.hasAppOpeningType) {
        return 'Отображается (открытие через GSM-звонок)';
      }
      return this.displayLabelApp(this.barrier.display_in_app);
    },
    infoDevices3 () {
      const gsmModuleInfo = this.barrier.gsm_module
        ? (() => {
          const phoneDigits = this.barrier.gsm_module.gsm_phone?.replace(/\D/g, '') || '';
          const displayPhone = phoneDigits.length === 10 ? '7' + phoneDigits : (this.barrier.gsm_module.gsm_phone || '');
          return `${displayPhone}${this.barrier.gsm_module.city_phone_number ? ` (${this.barrier.gsm_module.city_phone_number.phone_number})` : ''}${this.barrier.gsm_module.model ? ` - ${this.barrier.gsm_module.model}` : ''}${this.barrier.gsm_module.manufacturer ? ` (${this.barrier.gsm_module.manufacturer})` : ''}`;
        })()
        : null;
      return [
        { label: 'Направление движения', value: this.displayLabelDirection(this.barrier.direction), check: this.barrier.direction },
        { label: 'Тип открытия', value: '', check: this.barrier.opening_type },
        { label: 'Открытие по пультам', value: this.displayLabelMovements(this.barrier.remote_control), check: this.barrier.remote_control, brCheck: true },
        { label: 'Номер телефона для открытия', value: this.barrier.barrier_open_phone, check: this.barrier.barrier_open_phone },
        { label: 'GSM модуль', value: gsmModuleInfo, check: gsmModuleInfo },
        { label: 'Плательщик', value: this.barrier.payer, check: this.barrier.payer },
        { label: 'Статус состояния по ГРЗ', value: this.displayLabelStatusCondition(this.barrier.status_condition), check: this.barrier.status_condition },
        { label: 'Комментарий', value: this.barrier.comment, check: this.barrier.comment },
      ];
    },
  },
  methods: {
    ...mapActions({
      importSipStatus: 'Barriers/getSipStatus',
      getBarrier: 'Barriers/getBarrier',
      getSipHistory: 'Barriers/getSipHistory',
      addAdditionalAddress: 'Barriers/addAdditionalAddress',
      removeAdditionalAddress: 'Barriers/removeAdditionalAddress',
    }),
    displayLabelSettings (item, value) {
      return ENUM_LABELS[item]?.[value] || 'Не указано';
    },
    openAdditionalAddressesModal () {
      this.$refs.additionalModal.open();
    },
    handleAddAddress (newAdditionalAddress) {
      this.addAdditionalAddress({
        id: this.barrier.id,
        address: newAdditionalAddress,
      })
        .then((response) => {
          this.getData();
          this.$flash_success(response.data.message);
        })
        .catch((err) => {
          this.$flash_warning(err.data.message);
        });
    },
    handleRemoveAddress (additionalAddressId) {
      this.removeAdditionalAddress({
        idBarrier: this.barrier.id,
        idAddress: additionalAddressId,
      })
        .then((response) => {
          this.getData();
          this.$flash_success(response.data.message);
        })
        .catch((err) => {
          this.$flash_warning(err.data.message);
        });
    },
    getResidentialComplexesIndividual () {
      this.$router.push({ name: 'TheMapIndividualBarrier', params: { resComById: 'none', id: this.barrier.id } });
    },
    updateSipStatus () {
      this.isUpdatedSip = true;
      this.importSipStatus(this.barrier.id)
        .then((response) => {
          if (response?.data?.skipped) {
            this.$flash_warning('шлагбаум без мониторинга');
            return;
          }
          this.$flash_success('SIP статус обновился!');
          this.getSipHistory(this.barrier.id)
            .then((data) => {
              this.sipHistory = data;
            });
          this.getData();
        })
        .catch(() => {
          this.$flash_warning('Не удолось обновить SIP статус');
        })
        .finally(() => {
          this.isUpdatedSip = false;
        });
    },
    getData () {
      this.getBarrier({
        id: this.barrier.id,
      })
        .catch(() => {
          this.$flash_warning('Ошибка при загрузке информации');
        });
    },
    physicalStatus (item) {
      switch (item) {
        case 1: return 'Установлен';
        case 2: return 'Не установлен';
        case 3: return 'Без интернет соединения';
        case 4: return 'Пусконаладка';
        case 5: return 'Старый шлагбаум';
        default: return '';
      }
    },
    displayLabel (item) {
      return TYPE_BARRIER[item];
    },
    displayLabelDirection (item) {
      return ENTRY_REMOTE_CONTROLS[item];
    },
    displayLabelMovements (item) {
      return DIRECTION_MOVEMENTS[item];
    },
    displayLabelStatusCondition (item) {
      return STATUS_CONDITION[item];
    },
    displayLabelApp (item) {
      return DISPLAY_IN_APP[item];
    },
  },
};
</script>
<style lang="scss" scoped>
.card-header {
  border-radius: 16px;
  text-align: center;
  height: 50px;
  padding-top: 10px;
  background-color: rgba(224, 179, 137, 0.5);
}
.border {
  border-radius: 16px;
}
.border {
  border-radius: 16px;
}
.card-info {
  background-color: white;
  color: black;
  width: auto;
  box-shadow: none;
}
.btn-device-map {
  position: absolute;
  top: 10px;
  right: 25px;
}
.flex-container {
  display: flex;
}

.additional-addresses {
  color: black;
  font-weight: inherit;
  text-decoration: underline;
  cursor: pointer;
}

.label {
  flex: 0 0 37%;
}

.show-button {
  margin-left: 10px;
}

.border-left {
  border-left: 1px solid #707079;
}

.content {
  padding-left: 5px;
  display: block;
  word-wrap: break-word;
}

.device-info {
  font-weight: 400 !important;
  padding-left: 5px;
  font-size: 15px;
  word-wrap: break-word;
  font-family: 'Montserrat', sans-serif;
}
.v-application p {
  font-weight: 600;
  margin-bottom: 8px;
  font-size: 15px;
  font-family: 'Montserrat', sans-serif;
}
.hist-but {
  cursor: pointer;
  color: cornflowerblue;
  font-weight: 400 !important;
  font-size: 15px !important;
  margin-bottom: 0 !important;
}
.btn-download-sip {
  position: absolute;
  right: 22%;
  height: 60%;
}
@media screen and (max-width: 800px) {
  .label {
    flex: 0 0 50%;
  }
  .device-info {
    font-size: 14px;
  }
  .content {
    padding-top: 5px;
  }
  .v-application p {
    font-size: 15px;
    padding-top: 5px;
  }
  .btn-download-sip {
    right: 11%;
  }
}
@media screen and (max-width: 800px) {
}
@media screen and (max-width: 1000px) {
  .btn-device-map {
    top: 35px;
    right: 10px;
  }
}
</style>
